import React from 'react'
import {Row, Block} from 'jsxstyle'
import {ReactComponent as CheckmarkIcon} from '../../../common/assets/checkmark-fill-icon.svg'
import {ReactComponent as CrossIcon} from '../../../common/assets/minus-fill-icon.svg'
import {ReactComponent as HideIcon} from '../../../common/assets/eye-slash-icon.svg'
import {ReactComponent as RevealIcon} from '../../../common/assets/eye-fill-icon.svg'
import Tooltip from '@mui/material/Tooltip'
import {formatDate, formatDateWithHour} from '../../../common/utils/dateUtils'
import {XpertKnowledgeBufferDto} from '../../../services/XpertKnowledgeBuffer/type'

interface BufferRowProps {
  buffer: XpertKnowledgeBufferDto
  onClick: () => void
}

const XpertKnowledgeBufferRow: React.FC<BufferRowProps> = ({buffer, onClick}) => {
  const renderIcon = (status: boolean) =>
    status ? <CheckmarkIcon width={20} height={20} color="#23DC3D" /> : <CrossIcon width={20} height={20} color="#C6131B" />

  return (
    <Row
      display="grid"
      gridTemplateColumns="2fr 1fr 1fr 1fr 1fr 1fr auto"
      alignItems="center"
      columnGap="16px"
      padding="12px 20px"
      borderRadius="8px"
      backgroundColor="#FFFFFF"
      border="1px solid #E0E0E0"
      hoverBackgroundColor="#F7FAFD"
      cursor="pointer"
      props={{onClick: () => onClick()}}
    >
      <Tooltip title={buffer.reference}>
        <Block fontSize="16px" fontWeight={500} whiteSpace="nowrap" overflow="hidden" textOverflow="ellipsis">
          {buffer.reference}
        </Block>
      </Tooltip>

      <Block fontSize="14px" color="#666">
        {formatDateWithHour(buffer.createdAt)}
      </Block>

      <Block justifySelf="center">{renderIcon(buffer.transcriptStatus)}</Block>
      <Block justifySelf="center">{renderIcon(buffer.recordingStatus)}</Block>
      <Block justifySelf="center">{renderIcon(buffer.apiCallStatus)}</Block>
      <Block justifySelf="center" fontSize="14px" fontWeight={500} color="#333">
        {buffer.xpertKnowledgeStatus}
      </Block>

      <Row alignItems="center" justifyContent="center" padding="4px" borderRadius="4px" backgroundColor="transparent" hoverBackgroundColor="#F7FAFD">
        {!buffer.isHidden ? <RevealIcon width={18} height={18} color="#5A5A5A" /> : <HideIcon width={18} height={18} color="#5A5A5A" />}
      </Row>
    </Row>
  )
}

export default XpertKnowledgeBufferRow
